<template>
    <v-card class="rounded-xl elevation-3" flat>
        <create-dialog :isConfirmView="true" @decline="handleDeclineFromDialog" @accept="handleAcceptFromDialog"></create-dialog>
        
        <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
            Xác nhận thông tin cập nhật
            <v-spacer></v-spacer>
            
            <div class="d-flex align-center wrapper mx-1 my-1">
                <v-btn @click="fetchData(tab)" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon>
                </v-btn>
            </div>
            
            <v-divider vertical class="mx-4" v-if="tab == 0 || tab == 1"></v-divider>
            
            <v-btn v-if="tab == 0" color="teal darken-4" dark @click="dialog.state=true; item=null" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                <v-icon left>mdi-plus</v-icon> THÊM PHIẾU
            </v-btn>
            
            <v-btn v-if="tab == 2" @click="updateConfirmDialog=true" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"
                dark color="teal darken-4" style="text-transform: none;">
                <v-icon left> mdi-database-import</v-icon>
                CẬP NHẬT DỮ LIỆU
            </v-btn>
        </v-card-title>

        <div class="px-6 pb-0">
            <v-tabs v-model="tab" color="teal darken-4" class="custom-tabs" height="40">
                <v-tab class="font-weight-bold">Chờ xác nhận</v-tab>
                <v-tab class="font-weight-bold">Từ chối</v-tab>
                <v-tab class="font-weight-bold">Sẵn sàng nhập dữ liệu</v-tab>
                <v-tab class="font-weight-bold">Gia đình nhân viên</v-tab>
            </v-tabs>
        </div>
        
        <v-sheet class="grey lighten-4 py-4 px-6 mb-2" v-if="tab != 3" style="border-top: 1px solid #eee;">
            <div class="d-flex flex-wrap align-center">
                <v-text-field 
                    outlined 
                    hide-details 
                    v-model="search" 
                    label="Tìm kiếm nhanh..." 
                    dense 
                    prepend-inner-icon="mdi-magnify"
                    style="max-width: 300px; background-color: white;" 
                    class="rounded-lg mr-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn outlined color="green darken-1" class="rounded-lg font-weight-bold" style="height: 40px; text-transform: none; letter-spacing: normal;" @click="exportExcel">
                    <v-icon left>mdi-microsoft-excel</v-icon> Tải dữ liệu Excel
                </v-btn>
            </div>
        </v-sheet>

        <v-tabs-items v-model="tab">
            <!-- Tab 0: Chờ xác nhận -->
            <v-tab-item eager>
                <v-data-table class="my-custom-table"
                    :mobile-breakpoint="0"
                    height="600px" fixed-header
                    :headers="headers"
                    :items="pendingItems"
                    :loading="isLoading"
                    :search="search"
                    loading-text="Đang tải dữ liệu..."
                    :footer-props="{
                        itemsPerPageOptions:[ 50, 100, 200 ]
                    }"
                >
                    <template v-slot:[`item.employeeName`]="{item}">
                        <div class="d-flex align-center py-2">
                            <v-avatar size="36" class="elevation-1 grey lighten-3">
                                <v-img :src="item.avatar" alt="">
                                    <template v-slot:placeholder>
                                        <v-icon small>mdi-account</v-icon>
                                    </template>
                                </v-img>
                            </v-avatar>
                            <div class="ml-3">
                                <div class="font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">{{ item.employeeName }}</div>
                                <div class="caption grey--text">{{ item.employeeCode }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.view`]="{item}">
                        <v-btn x-small depressed rounded color="blue lighten-5" @click="openViewDialog(item)" class="mx-1 font-weight-bold blue--text text--darken-3">
                            <v-icon left small>mdi-eye</v-icon> Xem
                        </v-btn>
                    </template>

                    <template v-slot:[`item.createdAt`]="{item}">
                        <div class="caption font-weight-medium grey--text text--darken-2">
                            <v-icon x-small color="grey lighten-1">mdi-clock-outline</v-icon>
                            {{formatDate(item.createdAt, "DD/MM/YYYY HH:mm:ss")}}
                        </div>
                    </template>

                    <template v-slot:[`item.actions`]="{item}" >
                        <div class="d-flex align-center">
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="green lighten-4" @click="accept(item)" class="mx-1 font-weight-bold green--text text--darken-3">
                                <v-icon left small>mdi-check-circle</v-icon> Duyệt
                            </v-btn>
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="red lighten-4" @click="decline(item)" class="mx-1 font-weight-bold red--text text--darken-3">
                                <v-icon left small>mdi-close-circle</v-icon> Từ chối
                            </v-btn>
                            <v-btn v-if="item.status != 0" x-small depressed rounded color="blue-grey lighten-4" @click="undo(item)" class="mx-1 font-weight-bold blue-grey--text text--darken-3">
                                <v-icon left small>mdi-undo</v-icon> Hoàn tác
                            </v-btn>
                        </div>
                    </template>

                    <template v-slot:[`item.remove`]="{ item }">
                        <v-btn x-small depressed rounded color="grey lighten-4" @click="remove(item)" class="font-weight-bold red--text text--darken-2" v-if="item.status == 0">
                            <v-icon left small>mdi-delete</v-icon> Xóa
                        </v-btn>
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="$helper.formatStatus(item.status).color" dark small label class="font-weight-bold elevation-1">
                            {{$helper.formatStatus(item.status).text}}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-tab-item>

            <!-- Tab 1: Từ chối -->
            <v-tab-item eager>
                <v-data-table class="my-custom-table"
                    :mobile-breakpoint="0"
                    height="600px" fixed-header
                    :headers="headers"
                    :items="declinedItems"
                    :loading="isLoading"
                    :search="search"
                    loading-text="Đang tải dữ liệu..."
                    :footer-props="{
                        itemsPerPageOptions:[ 50, 100, 200 ]
                    }"
                >
                    <template v-slot:[`item.employeeName`]="{item}">
                        <div class="d-flex align-center py-2">
                            <v-avatar size="36" class="elevation-1 grey lighten-3">
                                <v-img :src="item.avatar" alt="">
                                    <template v-slot:placeholder>
                                        <v-icon small>mdi-account</v-icon>
                                    </template>
                                </v-img>
                            </v-avatar>
                            <div class="ml-3">
                                <div class="font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">{{ item.employeeName }}</div>
                                <div class="caption grey--text">{{ item.employeeCode }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.view`]="{item}">
                        <v-btn x-small depressed rounded color="blue lighten-5" @click="openViewDialog(item)" class="mx-1 font-weight-bold blue--text text--darken-3">
                            <v-icon left small>mdi-eye</v-icon> Xem
                        </v-btn>
                    </template>

                    <template v-slot:[`item.createdAt`]="{item}">
                        <div class="caption font-weight-medium grey--text text--darken-2">
                            <v-icon x-small color="grey lighten-1">mdi-clock-outline</v-icon>
                            {{formatDate(item.createdAt, "DD/MM/YYYY HH:mm:ss")}}
                        </div>
                    </template>

                    <template v-slot:[`item.actions`]="{item}" >
                        <div class="d-flex align-center">
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="green lighten-4" @click="accept(item)" class="mx-1 font-weight-bold green--text text--darken-3">
                                <v-icon left small>mdi-check-circle</v-icon> Duyệt
                            </v-btn>
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="red lighten-4" @click="decline(item)" class="mx-1 font-weight-bold red--text text--darken-3">
                                <v-icon left small>mdi-close-circle</v-icon> Từ chối
                            </v-btn>
                            <v-btn v-if="item.status != 0" x-small depressed rounded color="blue-grey lighten-4" @click="undo(item)" class="mx-1 font-weight-bold blue-grey--text text--darken-3">
                                <v-icon left small>mdi-undo</v-icon> Hoàn tác
                            </v-btn>
                        </div>
                    </template>

                    <template v-slot:[`item.remove`]="{ item }">
                        <v-btn x-small depressed rounded color="grey lighten-4" @click="remove(item)" class="font-weight-bold red--text text--darken-2" v-if="item.status == 0">
                            <v-icon left small>mdi-delete</v-icon> Xóa
                        </v-btn>
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="$helper.formatStatus(item.status).color" dark small label class="font-weight-bold elevation-1">
                            {{$helper.formatStatus(item.status).text}}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-tab-item>

            <!-- Tab 2: Sẵn sàng nhập dữ liệu -->
            <v-tab-item eager>
                <v-data-table class="my-custom-table"
                    :search="search"
                    :mobile-breakpoint="0"
                    height="600px" fixed-header
                    :headers="header2s"
                    :items="items1"
                    :loading="isLoading"
                    loading-text="Đang tải dữ liệu..."
                    :footer-props="{
                        itemsPerPageOptions:[ 50, 100, 200 ]
                    }"
                >
                    <template v-slot:[`item.employeeName`]="{item}">
                        <div class="d-flex align-center py-2">
                            <v-avatar size="36" class="elevation-1 grey lighten-3">
                                <v-img :src="item.avatar" alt="">
                                    <template v-slot:placeholder>
                                        <v-icon small>mdi-account</v-icon>
                                    </template>
                                </v-img>
                            </v-avatar>
                            <div class="ml-3">
                                <div class="font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">{{ item.employeeName }}</div>
                                <div class="caption grey--text">{{ item.employeeCode }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.view`]="{item}">
                        <v-btn x-small depressed rounded color="blue lighten-5" @click="openViewDialog(item)" class="mx-1 font-weight-bold blue--text text--darken-3">
                            <v-icon left small>mdi-eye</v-icon> Xem
                        </v-btn>
                    </template>

                    <template v-slot:[`item.createdAt`]="{item}">
                        <div class="caption font-weight-medium grey--text text--darken-2">
                            <v-icon x-small color="grey lighten-1">mdi-clock-outline</v-icon>
                            {{formatDate(item.createdAt, "DD/MM/YYYY HH:mm:ss")}}
                        </div>
                    </template>

                    <template v-slot:[`item.actions`]="{item}" >
                        <div v-if="!item.applyToEmployee" class="d-flex align-center"> 
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="green lighten-4" @click="accept(item)" class="mx-1 font-weight-bold green--text text--darken-3">
                                <v-icon left small>mdi-check-circle</v-icon> Duyệt
                            </v-btn>
                            <v-btn v-if="item.status == 0" x-small depressed rounded color="red lighten-4" @click="decline(item)" class="mx-1 font-weight-bold red--text text--darken-3">
                                <v-icon left small>mdi-close-circle</v-icon> Từ chối
                            </v-btn>
                            <v-btn v-if="item.status != 0" x-small depressed rounded color="blue-grey lighten-4" @click="undo(item)" class="mx-1 font-weight-bold blue-grey--text text--darken-3">
                                <v-icon left small>mdi-undo</v-icon> Hoàn tác
                            </v-btn>
                        </div>
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="$helper.formatStatus(item.status).color" label small outlined v-if="!item.applyToEmployee" class="font-weight-bold">
                            {{$helper.formatStatus(item.status).text}}
                        </v-chip>
                        <v-chip color="blue-grey lighten-4" text-color="blue-grey darken-3" label small class="font-weight-bold elevation-1" v-else>
                            <v-icon left small>mdi-database-check</v-icon> Đã cập nhật
                        </v-chip>
                    </template>
                    
                    <template v-slot:[`item.remove`]="{item}">
                        <v-btn x-small depressed rounded color="grey lighten-4" disabled class="font-weight-bold">
                            <v-icon left small>mdi-delete</v-icon> Xóa
                        </v-btn>
                    </template>
                </v-data-table>
            </v-tab-item>

            <!-- Tab 3: Gia đình nhân viên -->
            <v-tab-item eager>
                <div class="pa-4">
                    <family></family>
                </div>
            </v-tab-item>
        </v-tabs-items>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="dialogDelete" max-width="480px">
            <v-card class="rounded-xl">
                <v-card-title class="headline font-weight-bold grey--text text--darken-3 px-6 pt-6">
                    Xác nhận xóa phiếu
                </v-card-title>
                <v-card-text class="px-6 grey--text text--darken-1">
                    Bạn có chắc chắn muốn xoá phiếu này? Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="font-weight-bold" @click="dialogDelete=false">Thoát</v-btn>
                    <v-btn color="red darken-2" dark class="font-weight-bold rounded-lg px-6 elevation-2" @click="cfmDeleteItem">Xóa phiếu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Decline Confirmation Dialog -->
        <v-dialog v-model="declineDialog" max-width="480px">
            <v-card class="rounded-xl">
                <v-card-title class="headline font-weight-bold grey--text text--darken-3 px-6 pt-6">
                    Lý do từ chối #{{ targetItem ? targetItem.id : '' }}
                </v-card-title>
                <v-card-text class="px-6 pb-0 mt-2">
                    <v-textarea v-model="hrNote" outlined rows="3" label="Nhập lý do *" placeholder="Vui lòng nhập lý do từ chối phiếu này..." class="rounded-lg" color="red darken-2" :rules="[v => !!v || 'Lý do không được để trống']"></v-textarea>
                </v-card-text>
                <v-card-actions class="px-6 pb-6 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="font-weight-bold" @click="declineDialog=false">Hủy</v-btn>
                    <v-btn color="red darken-2" :dark="!!hrNote" :class="hrNote ? 'elevation-2' : 'elevation-0'" class="font-weight-bold rounded-lg px-6" @click="cfmDeclineItem" :disabled="!hrNote">Xác nhận</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Update Confirm Dialog -->
        <v-dialog max-width="500" v-model="updateConfirmDialog" persistent>
            <v-card class="rounded-xl pb-2">
                <v-card-title class="d-flex align-center px-6 pt-6 pb-4">
                    <v-avatar color="orange lighten-5" size="48" class="mr-3">
                        <v-icon color="orange darken-2">mdi-database-import</v-icon>
                    </v-avatar>
                    <div>
                        <div class="text-h6 font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">Cập nhật dữ liệu</div>
                        <div class="caption grey--text mt-1">Lưu thông tin vào hồ sơ nhân viên</div>
                    </div>
                </v-card-title>
                <v-card-text class="px-6 grey--text text--darken-2">
                    <v-alert type="warning" text dense class="rounded-lg">
                        Thao tác này sẽ cập nhật tất cả các phiếu "Sẵn sàng" vào thông tin nhân viên. Bạn có chắc chắn muốn tiếp tục?
                    </v-alert>
                </v-card-text>
                <v-card-actions class="px-6 pb-4 pt-2">
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-2" class="font-weight-bold rounded-lg mr-2 px-4" @click="updateConfirmDialog=false" :disabled="isUpdating">Hủy</v-btn>
                    <v-btn color="primary" dark class="font-weight-bold rounded-lg px-6 elevation-2" @click="updateToEmployee" :loading="isUpdating">Tiếp tục</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from './api';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import * as moment from "moment/moment";
import Create from '@/views/Base/InfoUpdate/Create';
import Family from './Family.vue'
import exportToExcel from '@/components/services/jsonToExcel';

export default {
    name: "InfoUpdateRequest",
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
        "create-dialog": Create,
        Family

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        
        tab(val) {
            if(val  == 0 || val == 1){
                this.fetchData(0)
            }
            if(val == 2) {
                this.fetchData(2)
            }
        },
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                console.log(this.tableParams,"////////");
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },
        month:{
            handler(val){
                this.filters.from=moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to=moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        }
    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        pendingItems() {
            return this.items.filter(x => x.status === 0);
        },
        declinedItems() {
            return this.items.filter(x => x.status === 2);
        }
    },
    data () {
        return {
            ROOT_URL: "infoUpdateRequests/",
            tab: 0,
            search: "",
            updateConfirmDialog: false,
            isUpdating: false,
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize:50
            },
            month: moment().format("YYYY-MM"),
            leavePlans:[],
            filters:{
                code: null,
                status: -1,
                employeeCode: null,
                employeeName: null,
                departmentCode: null,
                leavePlanCode:null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
                leaveAmountType: 2,
                execDate: moment().format("YYYY-MM-DD")
            },
            departmentSearch:null,
            departments: [],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            exportDialog:false,
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            items1: [],
            search:"",
            options: {},
            isLoading: true,

            dialog: {
                state: false,
                item: undefined,
            },
            item: null,
            dialogDelete: false,
            declineDialog: false,
            hrNote: '',
            targetItem: undefined,
            viewItem: null,
            viewDialog: false,

            headers: [
                { text: 'Thao tác', align:"center", value: 'actions', width: '100px'},
                { text: 'Xem phiếu', value: 'view', width: '100px', align: 'center', sortable: false},
                { text: 'Mã phiếu', align: 'start', value: 'id', width: '100px'},
                { text: 'Mã NS', class: 'd-none', cellClass: 'd-none', value: 'employeeCode', width: '7rem'},
                { text: 'Tên NS', align: 'start', value: 'employeeName', width: '14rem'},
                {
                    text: 'Ghi chú', align: 'start', value: 'hrNote', width: '10rem',
                    filter: value => true, filterable: false, sortable: false
                },
                { text: 'Ngày tạo', align: 'start', value: 'createdAt', width: '10rem'},
                { text: 'Trạng thái', align: 'start', value: 'status', width: '7rem'},
                // { text: 'Người tạo', align: 'start', value: 'createdBy'},
                { text: 'Xóa phiếu', value: 'remove', width: 150},
            ],
            
            header2s: [
                { text: 'Xem phiếu', value: 'view', width: '7rem', align: 'center', sortable: false},
                { text: 'Mã', align: 'start', value: 'id', width: '7rem'},
                { text: 'Mã NS', class: 'd-none', cellClass: 'd-none', value: 'employeeCode', width: '7rem'},
                { text: 'Tên NS', align: 'start', value: 'employeeName', width: '15rem'},
                { text: 'Ngày tạo', align: 'start', value: 'createdAt', width: '10rem'},
                { text: 'Trạng thái', align: 'start', value: 'status', width: '7rem'},
                // { text: 'Người tạo', align: 'start', value: 'createdBy'},
                { text: 'Xóa phiếu', value: 'remove', width: 100},
            ],
            filterExpand: false
        }
    },
    methods: {
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        formatDate(value, format = "DD/MM/YYYY") {
            return moment(value).format(format);
        },
        formatStatus(value){
            switch(value){
                case 0:{
                    return "Chờ duyệt";
                }
                case 1:{
                    return "Chấp nhận";
                }
                case 2:{
                    return "Từ chối";
                }
            }
        },
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        // fetchLeavePlan(){
        //     ApiServices.fetchLeavePlan().then(res=>{
        //         this.leavePlans = res.data;
        //     })
        // },
        fetchDepartment() {
            return http.get("departments/fetch", {
                params: {
                    search: this.departmentSearch
                }
            }).then(res => {
                this.departments = res.data;
            })
        },
        fetchData (tab = 0) {
            if (tab == 3) return;
            this.isLoading = true;
            if(tab == 0 || tab == 1) {
                
                return ApiServices.gets()
                .then(d => {
                    console.log(d)
                    this.items = d
                })
                .catch(err => {
                console.log(err)
                })
                .finally(() => {
                    this.isLoading = false;
                })
            }
            if(tab == 2){
                return ApiServices.readyGets()
                .then(d => {
                    this.items1 = d
                })
                .catch(err => {
                console.log(err)
                })
                .finally(() => {
                    this.isLoading = false;
                })
            }
        },
        
        accept(item) {
            return ApiServices.changeStatus(item.id, 1).then(res => {
                // let eventObj = {
                //     color: "success",
                //     message: "Cập nhật thành công",
                //     toast: true,
                // };
                // this.messageToast(eventObj);
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        decline(item) {
            this.targetItem = item;
            this.hrNote = '';
            this.declineDialog = true;
        },
        cfmDeclineItem() {
            if(!this.hrNote) return;
            return ApiServices.changeStatus(this.targetItem.id, 2, this.hrNote).then(res => {
                this.declineDialog = false;
                // Close the create dialog if it's open
                this.$root.$emit('closeCreateDialog');
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        handleDeclineFromDialog(form) {
            // Find the item from the form to match the targetItem format
            let item = this.items.find(x => x.id === form.id) || form;
            this.decline(item);
        },

        handleAcceptFromDialog(form) {
            let item = this.items.find(x => x.id === form.id) || form;
            this.accept(item).then(() => {
                this.$root.$emit('closeCreateDialog');
                this.fetchData();
                this.fetchData(2);
            });
        },

        undo(item) {
            return ApiServices.changeStatus(item.id, 0).then(res => {
                this.fetchData();
                this.fetchData(2);
            }).catch(err => {
                console.log(err)
            });
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete(this.ROOT_URL+"admin/"+this.targetItem.id).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
        exportExcel() {
            let dataToExport = [];
            let tabName = "";
            if (this.tab === 0) {
                dataToExport = this.pendingItems;
                tabName = "ChoXacNhan";
            } else if (this.tab === 1) {
                dataToExport = this.declinedItems;
                tabName = "TuChoi";
            } else if (this.tab === 2) {
                dataToExport = this.items1;
                tabName = "SanSangNhapDuLieu";
            }

            if (!dataToExport || dataToExport.length === 0) {
                alert("Không có dữ liệu để xuất");
                return;
            }

            const formattedData = dataToExport.map(item => ({
                "Id Phiếu": item.id,
                "Mã NS": item.employeeCode,
                "Tên NS": item.employeeName,
                "Ngày tạo": moment(item.createdAt).format("DD/MM/YYYY"),
                "Thời gian tạo": moment(item.createdAt).format("HH:mm:ss"),
                "Trạng thái": this.formatStatus(item.status)
            }));

            const fileName = `DanhSachCapNhatLylich_${tabName}_${moment().format('YYYYMMDD_HHmmss')}`;
            exportToExcel(formattedData, fileName);
        },

        openViewDialog(item){
            this.$root.$emit('editDialog', item)
            // this.viewDialog = true
            // this.viewItem = item
        },
        updateToEmployee() {
            this.isUpdating = true;
            return ApiServices.updateToEmployee().then(res => {
                this.updateConfirmDialog = false;
                this.fetchData(this.tab);
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.isUpdating = false;
            });
        }
    },
    created () {
        this.fetchData();
    }
}
</script>

<style scoped>
/* Use ::v-deep or >>> to target the inner <thead> */
.my-custom-table ::v-deep thead th {
  background-color: #F8F9FA !important; 
  height: 48px !important;
}

.my-custom-table ::v-deep thead th span {
  font-weight: 600 !important;
  color: #37474F !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.custom-tabs ::v-deep .v-tab {
    text-transform: none !important;
    letter-spacing: normal !important;
}

.my-custom-table ::v-deep tbody tr:hover {
    background-color: #F1F8E9 !important;
}
</style>